import { PaymentsFeatureFlags } from '@frontend/payments-hooks';
import { useActiveFeatureLocationIds } from './use-active-feature-location-ids';

export const usePaymentMethods = () => {
  const stripeAffirmPaymentLocations = useActiveFeatureLocationIds(PaymentsFeatureFlags.ShowStripeAffirmPaymentToggle);

  return { stripeAffirmPaymentLocations };
};
